module.exports = __webpack_public_path__ + "static/media/2-1.d11bfe40.webp";